<span class="scalarClose" (click)="closeScalar()">
    <div class="dim-icon dim-close"></div>
</span>
